import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching subject question bank
export const fetchSubjectQuestionBank = createAsyncThunk(
    'questionBank/fetchSubjectQuestionBank',
    async (subjectId, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token3almny');
            const response = await axios.get(
                `https://newalemny.3almny.app/api/subjects/subject_question_bank/${subjectId}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'حدث خطأ في تحميل بنك الأسئلة'
            );
        }
    }
);

const initialState = {
    questionBank: [],
    loading: false,
    error: null,
    pagination: {
        current_page: 1,
        total: 0,
        per_page: 10,
        pages_count: 0
    }
};

const questionBankSlice = createSlice({
    name: 'questionBank',
    initialState,
    reducers: {
        clearQuestionBank: (state) => {
            state.questionBank = [];
            state.error = null;
            state.pagination = {
                current_page: 1,
                total: 0,
                per_page: 10,
                pages_count: 0
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubjectQuestionBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSubjectQuestionBank.fulfilled, (state, action) => {
                state.loading = false;
                // Handle the new response structure
                const responseData = action.payload.result?.data || action.payload.data || [];
                state.questionBank = responseData;
                state.pagination = action.payload.result || {
                    current_page: 1,
                    total: 0,
                    per_page: 10,
                    pages_count: 0
                };
                state.error = null;
            })
            .addCase(fetchSubjectQuestionBank.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearQuestionBank } = questionBankSlice.actions;
export default questionBankSlice.reducer;
